const domain: string = 'PRELEVEMENT'

export const SAVE_PRELEVEMENT: string = `${domain}/SAVE_PRELEVEMENT`